import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import reducers from "./ducks";
import sagas from "./sagas";

const persistedRedurcer = persistReducer(
  {
    key: "webcol-kemira-6.0.0",
    whitelist: ["auth", "selectedCompany", "language", "printingData"],
    storage,
  },
  reducers,
);

const middlewares = [];

const sagaMiddleware = createSagaMiddleware({
  onError: (error, errorInfo): void => {
    console.log("SAGA ERROR", error, errorInfo);
  },
});

middlewares.push(sagaMiddleware);

const composer = compose(applyMiddleware(...middlewares));

const store = createStore(persistedRedurcer, composer);
const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

sagaMiddleware.run(sagas);

export { store, persistor };
